import React, { useEffect, useState } from 'react';
import { Box, Text, HStack, IconButton, Spacer } from '@chakra-ui/react';
import { ChatIcon, DeleteIcon } from '@chakra-ui/icons';
import { string } from 'prop-types';

export enum ColorOption {
  red = 'red',
  blue = 'blue',
  green = 'green',
  yellow = 'yellow',
  neutral = 'neutral',
  transparent = 'transparent',
}
export const colorOptionValue: Record<ColorOption, string> = {
  [ColorOption.red]: '#ff7e7e',
  [ColorOption.blue]: '#9c9cff',
  [ColorOption.green]: '#69ff69',
  [ColorOption.yellow]: 'yellow',
  [ColorOption.neutral]: '#d0e9ff',
  [ColorOption.transparent]: 'transparent',
};

interface DropdownProps {
  markId: string;
  color: ColorOption;
  comment?: string;
  updateColor: (color: ColorOption) => void;
  deleteNote?: () => void;
  onComment?: () => void;
}

const Dropdown = (props: DropdownProps) => {
  const {
    markId,
    comment,
    color: initalColor,
    updateColor,
    deleteNote,
    onComment,
  } = props;

  const [color, setColor] = useState<ColorOption>(initalColor);

  useEffect(() => {
    onColorSelect(color);
  }, [color]);

  const onColorSelect = (colorOption: ColorOption) => {
    const markEl = document.querySelector(`#${markId}`) as any;
    if (markEl) {
      markEl.style.background = colorOptionValue[colorOption];
    }
  };

  return (
    <Box pointerEvents="all" padding="20px">
      <Text
        id={`comment-${markId}`}
        w="100%"
        textAlign="center"
        marginBottom={8}
      >
        {comment || ''}
      </Text>
      <HStack justifyContent="center">
        {[
          ColorOption.red,
          ColorOption.blue,
          ColorOption.green,
          ColorOption.yellow,
        ].map((colorOption) => {
          const isSelected = colorOption === color;
          return (
            <button
              key={colorOption}
              onClick={(e) => {
                setColor(colorOption);
                updateColor(colorOption);
                e.stopPropagation();
                e.preventDefault();
              }}
              style={{
                background: colorOption,
                width: 20,
                height: 20,
                borderRadius: 20,
                border: isSelected ? '3px solid white' : 'none',
              }}
            ></button>
          );
        })}
        {(deleteNote || onComment) && (
          <Spacer maxW={4} borderLeft="1px solid #AAA" />
        )}
        {deleteNote && (
          <IconButton
            onClick={() => {
              setColor(ColorOption.transparent);
              deleteNote();
            }}
            variant="outline"
            colorScheme="blue"
            aria-label="Delete note"
            icon={<DeleteIcon />}
          />
        )}
        {onComment && (
          <IconButton
            onClick={onComment}
            variant="outline"
            colorScheme="blue"
            aria-label="Delete note"
            icon={<ChatIcon />}
          />
        )}
      </HStack>
    </Box>
  );
};

export default Dropdown;
